import { BaseOption, SelectValueType } from 'ui/selects';
import { FbAccountId, FbCustomAudience } from 'modules/workflows/types';

export const getAudienceLabel = (audienceId = '', audienceName = '') =>
  `${audienceId} - ${audienceName}`;

export const getAccountIdDropdownOptions = (
  options: FbAccountId[],
): BaseOption<SelectValueType>[] => {
  return options.map((account: FbAccountId) => ({
    id: account,
    label: account,
    value: account,
  }));
};

export const getCustomAudienceDropdownOptions = (
  options: FbCustomAudience[],
): BaseOption<SelectValueType>[] => {
  return options.map((audience: FbCustomAudience) => ({
    id: `${audience.customAudienceId}`,
    label: getAudienceLabel(audience.customAudienceId, audience.name),
    value: audience.customAudienceId,
    data: audience,
  }));
};
